/**
 * Simple LazyImage component for performance optimization
 */
export default function LazyImage({ 
  src, 
  alt, 
  className = '', 
  width, 
  height, 
  eager = false,
  style = {},
  ...rest 
}) {
  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      className={className}
      style={style}
      {...rest}
    />
  );
}